module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Arrows-v-afd5980c6032e3d8a358eb9d0dc13389.svg";